import { AgeGate } from "@/components/AgeGate";
import { Hero } from "@/components/Hero";
import { PromoTicker } from "@/components/PromoTicker";
import { DailyDeals } from "@/components/DailyDeals";
import { ProductGrid } from "@/components/ProductGrid";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";

export default function Home() {
  return (
    <>
      <AgeGate />
      <Hero />
      <PromoTicker />
      <DailyDeals />
      <ProductGrid />
      <Footer />
      <StickyBar />
    </>
  );
}
